"use client"

import { useState } from "react"
import { HiVolumeOff, HiVolumeUp } from "react-icons/hi"
import { ChevronRight, Home } from "lucide-react"

const BannerContactSection = () => {
    const [isMuted, setIsMuted] = useState(true)

    const toggleMute = () => {
        setIsMuted(!isMuted)
    }

    return (
        <section className="relative w-full bg-white">
            {/* CSS Animation */}
            <style dangerouslySetInnerHTML={{
                __html: `
                @keyframes bounce-horizontal {
                    0%, 100% { transform: translateX(0); animation-timing-function: cubic-bezier(0.8, 0, 1, 1); }
                    50% { transform: translateX(-25%); animation-timing-function: cubic-bezier(0, 0, 0.2, 1); }
                }
            `}} />

            <div className="relative w-full px-4 md:px-6 lg:px-8">
                <div className="relative w-full h-[280px] md:h-[360px] lg:h-[420px] rounded-2xl overflow-hidden group">
                    {/* Hình nền */}
                    <img
                        src="/images/Contact/contact.jpg"
                        alt="Contact Background"
                        className="absolute inset-0 w-full h-full object-cover object-[center_38%]"
                    />

                    {/* BREADCRUMB  */}
                    <div
                        className="hidden md:flex absolute top-2 left-2 xl:top-4 xl:left-4 2xl:top-5 2xl:left-5 min-[1920px]:top-8 min-[1920px]:left-8 items-center gap-1 text-white z-20"
                        style={{ fontFamily: '"Plus Jakarta Sans", sans-serif' }}
                    >
                        <Home className="size-3 xl:size-3.5 2xl:size-4 min-[1920px]:size-5" strokeWidth={2} />
                        <ChevronRight className="size-2.5 xl:size-3 2xl:size-3.5 min-[1920px]:size-4 opacity-70" />
                        <span className="text-[10px] xl:text-xs 2xl:text-[13px] min-[1920px]:text-base font-light tracking-wide">
                            Liên hệ
                        </span>
                    </div>

                </div>

                {/* CHỮ "SCROLL DOWN →"  */}
                <div className="hidden lg:block absolute bottom-30 right-0 -translate-x-1 -rotate-90 origin-bottom-right z-12">
                    <div className="flex items-center gap-2 text-black/60">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1"
                            stroke="currentColor"
                            className="w-5 h-5"
                            style={{ animation: 'bounce-horizontal 1s infinite' }}
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                        </svg>
                        <p className="font-normal tracking-[0.12em] text-[10px] uppercase whitespace-nowrap">Scroll Down</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BannerContactSection